import {FC} from 'react'

type Props = {
  userData?: string
}

const UserInfoBox: FC<Props> = ({userData}) => (
  <div className='text-gray-800 text-hover-primary mb-1'>{userData}</div>
)

export {UserInfoBox}
